/**
 * Male/female upper, lower and standard-deviation limits for one metric datapoint under a
 * training level and sport. `units` follows the same `"primary"` / `"secondary"` / plain-unit
 * convention as {@link IDatapoint} — resolve via the sport's reference system before display.
 */
export interface ITrainingLevelLimit {
  sport: number;
  metric_slug: string;
  datapoint_id: string;
  metric_name: string;
  datapoint_name: string;
  units: string;
  male_upper: number;
  male_lower: number;
  male_stdDev: number;
  female_upper: number;
  female_lower: number;
  female_stdDev: number;
}

/** PATCH body item — the endpoint takes a bare array; every item is self-identifying. */
export type ITrainingLevelLimitPatchItem = ITrainingLevelLimit;

export const EMPTY_TRAINING_LEVEL_LIMITS: ITrainingLevelLimit[] = [];
